
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M12.05 10.68h125.91v87.59H12.05zM137.96 125.64H61.31M33.95 125.64H12.04"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"47.63","cy":"125.64","r":"13.69"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M55.84 27.1l43.8 27.37-43.8 27.37V27.1z"}})])
          )
        }
      }
    